import { Component, OnInit } from '@angular/core';
import { RoleService } from '../../../services/core/role/role.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
@UntilDestroy()

@Component({
  selector: 'app-list-role',
  templateUrl: './list-role.component.html',
  styleUrls: ['./list-role.component.css']
})
export class ListRoleComponent implements OnInit {
  roles:any;
  search:any
  totalPages = 0;
  totalResults = 0;
  currentPage: number = 1;
  numberOfRecords = NUMBER_OF_RECORDS;
  userPermission=UserPermission
  constructor(
    private roleService: RoleService, public permissionService: PermissionService
  ){}
  ngOnInit(): void {
    this.getRoles(this.currentPage)
  }

  getRoles(page: number) {
    const queryparams = {
      limit: 50,
      page
    }
  this.roleService.getRoles(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.roles = data.results
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getRoles(page);
  }

}
